import * as React from 'react';

/** Material UI Packages. */
import { Box, Button, Chip } from '@mui/material';

/** Material UI Icons. */
import ClearIcon from '@mui/icons-material/Clear';

/**
 * Shows the operator which conditions the results above are cut by ("Client: ACME"), and
 * lets them drop one or all. Dropping only changes the filters; results change on the next search.
 *
 * @param {Array<{key: string, label: string, text: string}>} filters - Applied filters.
 * @param {function} onRemove - Called with the chip's key.
 * @param {function} onClearAll - Called when CLEAR ALL is pressed.
 */
export default function AppliedFilterChips({ filters, onRemove, onClearAll }) {
    if (!filters.length) return null;
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75, mb: 1 }}>
            {filters.map(({ key, label, text }) => (
                <Chip
                    key={key}
                    size="small"
                    label={`${label}: ${text}`}
                    onDelete={() => onRemove(key)}
                    sx={{ fontSize: '12px', height: 24, bgcolor: 'rgba(0, 100, 126, 0.08)', color: '#003a52' }}
                />
            ))}
            <Button
                size="small"
                onClick={onClearAll}
                startIcon={<ClearIcon sx={{ fontSize: '14px !important' }} />}
                sx={{ fontSize: '12px', textTransform: 'none', color: '#00647e', minWidth: 0, px: 1 }}
            >
                Clear all
            </Button>
        </Box>
    );
}
